const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "https://backend.aifia.in") + "/api";

// Helper function to make API requests
const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem("token");
  
  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    ...options,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Something went wrong");
    }

    return data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

// Auth API
export const authAPI = {
  login: (email, password) => {
    return apiRequest("/admin/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
  },
  logout: () => {
    return apiRequest("/admin/auth/logout", { method: "POST" });
  },
  getMe: () => {
    return apiRequest("/admin/auth/me");
  },
};


// Applications API
export const applicationsAPI = {
  getAll: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return apiRequest(`/admin/applications${queryString ? `?${queryString}` : ""}`);
  },
  getById: (id) => {
    return apiRequest(`/admin/applications/${id}`);
  },
  review: (id, data) => {
    return apiRequest(`/admin/applications/${id}/review`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },
  updateDocuments: (id, data) => {
    return apiRequest(`/admin/applications/${id}/documents`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },
  delete: (id) => {
    return apiRequest(`/admin/applications/${id}`, { method: "DELETE" });
  },
};

// Payments API
export const paymentsAPI = {
  getAll: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return apiRequest(`/admin/payments${queryString ? `?${queryString}` : ""}`);
  },
  getById: (id) => {
    return apiRequest(`/admin/payments/${id}`);
  },
  verify: (id, data) => {
    return apiRequest(`/admin/payments/${id}/verify`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },
  update: (id, data) => {
    return apiRequest(`/admin/payments/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },
};

// Renewals API
export const renewalsAPI = {
  getAll: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return apiRequest(`/admin/renewals${queryString ? `?${queryString}` : ""}`);
  },
  getById: (id) => {
    return apiRequest(`/admin/renewals/${id}`);
  },
};

// Contact Messages API
export const contactAPI = {
  getAll: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return apiRequest(`/admin/contact${queryString ? `?${queryString}` : ""}`);
  },
  getById: (id) => {
    return apiRequest(`/admin/contact/${id}`);
  },
  reply: (id, data) => {
    return apiRequest(`/admin/contact/${id}/reply`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },
  markAsRead: (id) => {
    return apiRequest(`/admin/contact/${id}/read`, {
      method: "PUT",
    });
  },
  delete: (id) => {
    return apiRequest(`/admin/contact/${id}`, { method: "DELETE" });
  },
};

// Reviews API
export const reviewsAPI = {
  getAll: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return apiRequest(`/admin/reviews${queryString ? `?${queryString}` : ""}`);
  },
  getById: (id) => {
    return apiRequest(`/admin/reviews/${id}`);
  },
  delete: (id) => {
    return apiRequest(`/admin/reviews/${id}`, { method: "DELETE" });
  },
};

// Public API (for checking application/payment status)
export const publicAPI = {
  checkApplicationStatus: (applicationNumber) => {
    return apiRequest(`/applications/status/${applicationNumber}`);
  },
  checkPaymentStatus: (paymentNumber) => {
    return apiRequest(`/payments/status/${paymentNumber}`);
  },
};

export default {
  auth: authAPI,
  applications: applicationsAPI,
  payments: paymentsAPI,
  renewals: renewalsAPI,
  contact: contactAPI,
  reviews: reviewsAPI,
  public: publicAPI,
};
